import {IdNameUsed} from '@domain/id-name-used';
import {EnumUtils, PresetColors} from '@vdw/angular-component-library';

export class Shift extends IdNameUsed {
  private _color: PresetColors;

  public constructor(id: number, name: string, color: PresetColors, used: boolean = false) {
    super(id, name, used);
    this._color = color;
  }

  public get color(): PresetColors {
    return this._color;
  }

  public set color(value: PresetColors) {
    this._color = value;
  }

  public static fromJSON(shiftJSON: any): Shift {
    return new Shift(shiftJSON.id, shiftJSON.name, PresetColors[shiftJSON.color], shiftJSON.used);
  }

  public toJSON(): JSON {
    return {
      name: this._name,
      color: EnumUtils.getKeyFromValue(PresetColors, this._color)
    } as any as JSON;
  }
}
